module.exports = __webpack_public_path__ + "static/media/DonateCarousel_5.df772a06.jpg";